import React, { ReactNode, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';
import { getDefaultDateRange } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsFormWrapper/InsightsFormWrapper.utils';
import {
  DATE_RANGE_KEY,
  INSIGHTS_LOCATIONS_KEY,
} from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/constants/businessInsights';

export interface InsightsFormFields {
  [DATE_RANGE_KEY]: {
    from: Date;
    to: Date;
  };
  [INSIGHTS_LOCATIONS_KEY]: {
    id: string;
    displayName: string;
  }[];
}

interface InsightsFormWrapperProps {
  children: ReactNode;
}

export const InsightsFormWrapper: React.FC<InsightsFormWrapperProps> = ({
  children,
}) => {
  const { filterDetails, dataLastUpdated } = useBusinessInsightsContext();

  const defaultValues = useMemo<InsightsFormFields>(() => {
    const { from, to } = getDefaultDateRange(filterDetails, dataLastUpdated);

    return {
      [DATE_RANGE_KEY]: {
        from,
        to,
      },
      [INSIGHTS_LOCATIONS_KEY]: [],
    };
  }, [filterDetails, dataLastUpdated]);

  const methods = useForm<InsightsFormFields>({
    mode: 'onChange',
    defaultValues,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
